// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3NYfU","title":"Header_title__3VKBt","left":"Header_left__1N8SA","clinicName":"Header_clinicName__Wh_8P"};